import React, { useMemo } from 'react';
import { Map } from 'immutable';
import elements from 'components/elements';

import Tooltip from 'components/mui/Tooltip';
import { Cell } from 'components/Tables/Cells/DescriptionCell/StyledComponents';

const DescriptionCell = ({ data }) => {
  const { hint, text, style } = data;
  const t = hint || text;

  const cellStyle = useMemo(() => {
    if (Map.isMap(style)) return style.toJS();

    return {};
  }, [style]);

  return (
    <Tooltip t={t} placement="top" disableFocusListener>
      <Cell
        // .cell-text-parent use for calculating autosize columns etc
        // src/components/Tables/grid/withResize/withResize.jsx
        className="cell-text-parent"
        sx={{
          fontWeight: data.bold ? 'bold' : 'normal',
        }}
        style={cellStyle}
        data-element={elements.je.description.container} // dont rm - styles applied to this attribute
        data-element-id={`${data._cell}-${data.type}`}
      >
        {data.link ? (
          <a href={data.link} target="_blank" rel="noopener noreferrer">
            {data.text}
          </a>
        ) : (
          // className .cell-text use for detect full width of text for resizing columns
          // src/components/Tables/grid/withResize/withResize.jsx
          <span className="cell-text">{data.text}</span>
        )}
      </Cell>
    </Tooltip>
  );
};

export default DescriptionCell;
